import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import Select from 'react-select';
import { customStyles } from '../../../../HelperFunctions';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from 'axios';
import { adminMainUrl } from '../../../../Config';
import { useDispatch, useSelector } from 'react-redux';
import { getCompanyBranch, getJobOrderEmployeeList } from '../../../../Redux/action/Joborder/JoborderAction';

const AddJobOrderByQuotationOffcanvas3 = ({
    token,
    user_id,
    show,
    handleClose,
    quotation_id,
    quotation_no,
    companyName,
    company_id,
    trans_mode,
    trans_type,
}) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [nextJobOrderNumber, setNextJobOrderNumber] = useState({ sequence: 1, year: new Date().getFullYear().toString().slice(-2) });
    const [loadingJobOrders, setLoadingJobOrders] = useState(false);

    const getPrefix = (mode, type) => {
        if (mode === 'Air' && type === 'Export') return 'AE';
        if (mode === 'Air' && type === 'Import') return 'AI';
        if (mode === 'Sea' && type === 'Export') return 'SE';
        if (mode === 'Sea' && type === 'Import') return 'SI';
        return null;
    };

    const getFormattedJobNumber = (seq, year, mode, type) => {
        const prefix = getPrefix(mode, type);
        if (!prefix) return 'CDL/-----/-----/--';
        return `CDL/${prefix}/${seq.toString().padStart(5, '0')}/${year}`;
    };

    const initialValues = {
        trans_mode: "",
        trans_type: "",
        quotation_id: "",
        customer_id: "",
        customer_branch_id: "",
        job_owner_id: "",
        has_quotation: true,
        is_direct_customer: false,
    };


    const [branchOption, setBranchOption] = useState([]);
    const [employeeOptions, setEmployeeOptions] = useState([]);

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            // console.log(values);
            setDisableSubmit(true);
            if (!values.customer_branch_id) {
                values.customer_branch_id = null;
            }
            if (company_id) {
                values.customer_id = company_id
            }

            const seq = nextJobOrderNumber.sequence || 1;
            const year = nextJobOrderNumber.year || new Date().getFullYear().toString().slice(-2);
            values.job_order_no = getFormattedJobNumber(seq, year, values.trans_mode, values.trans_type);

            // console.log(values);
            try {
                let config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }


                axios.post(`${adminMainUrl}/api/jobOrder/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            navigate(`/flexichain/job-order/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        const fetchJobOrders = async () => {
            const mode = formik.values.trans_mode;
            const type = formik.values.trans_type;
            const prefix = getPrefix(mode, type);
            if (!show || !prefix) {
                const currentYear = new Date().getFullYear().toString().slice(-2);
                setNextJobOrderNumber({ sequence: 1, year: currentYear });
                return;
            }
            setLoadingJobOrders(true);
            try {
                const config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id'),
                    },
                };
                const response = await axios.post(
                    `${adminMainUrl}/api/jobOrder/latestJobOrderlist`,
                    { prefix },
                    config
                );
                const currentYear = new Date().getFullYear().toString().slice(-2);
                let maxSequence = 0;
                if (response.status === 200 && response.data?.data) {
                    const latestJobNo = response.data.data.job_order_unique_no;
                    if (latestJobNo) {
                        const regex = new RegExp(`CDL/${prefix}/(\\d+)/\\d{2}`);
                        const match = latestJobNo.match(regex);
                        if (match) {
                            const seq = parseInt(match[1], 10);
                            if (!isNaN(seq)) maxSequence = seq;
                        }
                    }
                }
                const nextSequence = maxSequence + 1;
                setNextJobOrderNumber({ sequence: nextSequence, year: currentYear });
            } catch (error) {
                console.error(error);
                const currentYear = new Date().getFullYear().toString().slice(-2);
                setNextJobOrderNumber({ sequence: 1, year: currentYear });
            } finally {
                setLoadingJobOrders(false);
            }
        };
        fetchJobOrders();
    }, [show, formik.values.trans_mode, formik.values.trans_type]);

    useEffect(() => {
        dispatch(getJobOrderEmployeeList(token, user_id));
    }, [])

    useEffect(() => {
        if (quotation_id) {
            formik.setFieldValue("quotation_id", quotation_id)
        } else {
            formik.setFieldValue("quotation_id", "")
        }
    }, [quotation_id]);

    useEffect(() => {
        if (company_id) {
            formik.setFieldValue("customer_id", company_id);
            dispatch(getCompanyBranch(token, user_id, company_id));
        } else {
            formik.setFieldValue("customer_id", "");
            setBranchOption([]);
        }
    }, [company_id]);

    useEffect(() => {
        if (trans_mode) {
            formik.setFieldValue("trans_mode", trans_mode)
        } else {
            formik.setFieldValue("trans_mode", "")
        }
    }, [trans_mode]);
    useEffect(() => {
        if (trans_type) {
            formik.setFieldValue("trans_type", trans_type)
        } else {
            formik.setFieldValue("trans_type", "")
        }
    }, [trans_type]);


    const {

        loadingJobOrderCompanyBranchList,
        JobOrderCompanyBranchList,
        JobOrderCompanyBranchListError,

        loadingJobOrderEmployeeList,
        JobOrderEmployeeListError,
        JobOrderEmployeeList,

    } = useSelector(state => state?.JoborderReducer);


    useEffect(() => {
        if (JobOrderCompanyBranchList) {
            let arr = [];
            JobOrderCompanyBranchList.map(v => { arr.push({ value: v.id, label: v.branch_name }) });
            setBranchOption(arr);
        }
    }, [JobOrderCompanyBranchList]);

    useEffect(() => {
        if (JobOrderEmployeeList) {
            let arr = [];
            JobOrderEmployeeList.map(val => { arr.push({ value: val.user_id, label: val.name }) });
            setEmployeeOptions(arr);
        }
    }, [loadingJobOrderEmployeeList, JobOrderEmployeeListError, JobOrderEmployeeList]);


    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement={"end"} name={"end"}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add Job Order</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-md-6 mt-2">
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Quotation
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            value={quotation_no}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mt-2">
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Transport Mode
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <select
                                            className="form-control form-control-sm"
                                            name="trans_mode"
                                            onBlur={formik.handleBlur}
                                            value={formik.values.trans_mode}
                                            disabled={true}
                                        >
                                            <option value="">-</option>
                                            <option value="Air">Air</option>
                                            <option value="Sea">Sea</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mt-2">
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Transport Type
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <select
                                            className="form-control form-control-sm"
                                            name="trans_type"
                                            onBlur={formik.handleBlur}
                                            value={formik.values.trans_type}
                                            disabled={true}
                                        >
                                            <option value="">-</option>
                                            <option value="Import">Import</option>
                                            <option value="Export">Export</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 mt-2">
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Customer
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            value={companyName}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 mt-2">
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Branch
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select
                                            className='custom-selector'
                                            options={branchOption}
                                            styles={customStyles}
                                            name="customer_branch_id"
                                            onChange={option => {
                                                formik.setFieldValue('customer_branch_id', option.value);
                                            }}
                                            value={formik.values.customer_branch_id ? branchOption.find(option => option.value == formik.values.customer_branch_id || null) : null}
                                        // value={}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* <div className="col-md-6 mt-2">
                                                <div className='ms-2 input_box_section'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Sales Person
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='mt-2 custom-selector '
                                                            options={customerOptions}
                                                            name="role_id"
                                                        />
                                                    </div>
                                                </div>
                                            </div> */}




                            <div className="col-md-6 mt-2">
                                <div className='ms-2 '>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Job Owner
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select
                                            className='custom-selector'
                                            options={employeeOptions}
                                            styles={customStyles}
                                            name="job_owner_id"
                                            onChange={option => {
                                                formik.setFieldValue('job_owner_id', option.value);
                                            }}
                                        // value={formik.values.job_owner_id}
                                        // isLoading={loadingEmployee}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row d-flex justify-content-end mt-2">
                            <div className="col-md-6 d-flex justify-content-end">
                                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                    {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Save and Next"}
                                </button>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default AddJobOrderByQuotationOffcanvas3